import { useEffect } from 'react';
import { Image } from 'semantic-ui-react';
import './HomePage.scss';
import PageContainer from './PageContainer';

const HomePage = () => {
  return (
    <PageContainer>
      <div className="gm-home-page">
        <Image src="/static/logo.svg" size="massive" />
      </div>
    </PageContainer>
  );
};

export default HomePage;
